import { Text } from "@mantine/core";
import Section from "src/components/shared/EntriesGenerator/Section/Section/Section";
import Loader from "src/components/shared/Loader/Loader";
import { type ISection } from "src/interfaces";

interface Props {
  sections: ISection[] | undefined;
  loading: boolean;
}

const ExportEntrySections = ({ sections, loading }: Props) => {
  if (loading) return <Loader />;
  if (!sections)
    return (
      <Text fz={60} c="gray.4" ta="center" mt="lg">
        No Data Available
      </Text>
    );

  return (
    <>
      {sections.map((s, i) => (
        <Section key={i} sIndex={i} section={s} />
      ))}
    </>
  );
};

export default ExportEntrySections;
